module.exports = __webpack_public_path__ + "img/female4.d6cf1ae2.jpeg";